@if(this.userAuthService.checkPermission('MANAGE.SERVICES.ENVIRONMENTS.ADD')){
<div class="mt-2 pr-0 col-12 d-flex justify-content-end align-items-center mb-05">
  <button class="add-env-btn" (click)="addEnvironment()">+ Add Environment
    <mat-icon mat-icon-button matSuffix matTooltip="Click on the button to add a new environment"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
  </button>
</div>
}

<div id="environment-list">
  <ag-grid-angular [style]="styleChipDiv" [infiniteInitialRowCount]="infiniteInitialRowCount"
    class="ag-theme-material"
    [rowData]="environmentTableRowData"
    [columnDefs]="columnDefs"
    [overlayNoRowsTemplate]="overlayNoRowsTemplate"
    [defaultColDef]="defaultColDef"
    rowSelection="single" [rowModelType]="rowModelType"
    (cellClicked)="handleTableCellClick($event)" (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div>

<app-slider (closeSliderFunc)="closeNav()" [sliderHeader]="(mode === 'edit') ? 'Modify Environment' : 'Add Environment'">
  @if(mode === 'add'){
  <app-add-environment (close)="closeNav()" (environmentAdded)="handleEnvironmentAdded()"></app-add-environment>
  }
  @if(mode === 'edit'){
  <app-edit-environment [environment]="environmentBeingEdited"
    (environmentFormSubmitted)="handleEditEnvironmentSubmit()" (editCancelled)="closeNav()"></app-edit-environment>
  }
  <ng-content></ng-content>
</app-slider>

<!-- Service Mapping Dialog Popup -->
<!-- <app-service-mapping-dialog
  *ngIf="isServiceMappingDialogVisible"
  [mappedServicesList]="mappedServicesForDialog"
  (dialogClosed)="hideServiceMappingDialog()">
</app-service-mapping-dialog> -->